import { render, staticRenderFns } from "./CustomViewConfig.vue?vue&type=template&id=7df9e5d9"
import script from "./CustomViewConfig.vue?vue&type=script&lang=js"
export * from "./CustomViewConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports